import gql from 'graphql-tag';

import client from '../graphqlAPI';

const DISMISS_DUPLICATE_PAIR = gql`
  mutation dismissDuplicatePair($pairId: String, $accountIds: [String], $dismissed: Boolean) {
    dismissDuplicatePair(pairId: $pairId, accountIds: $accountIds, dismissed: $dismissed) {
      isAuth
      result
      pairId
      dismissed
      error
    }
  }
`;

const dismissDuplicatePair = async (variables) => {
  try {
    const result = await client.mutate({
      mutation: DISMISS_DUPLICATE_PAIR,
      variables,
      errorPolicy: 'all',
      fetchPolicy: 'no-cache',
    });

    const { data: { dismissDuplicatePair: data } } = result;

    if (data) return data;
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Mutation Error: dismissDuplicatePair = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: dismissDuplicatePair Error: ${error}`);
    return null;
  }
};

export default dismissDuplicatePair;
